import React from "react";
import { useTranslation } from "react-i18next";

import Question from "./components/Question";

import classes from "./index.module.css";

const Questions = () => {
  const { t } = useTranslation();

  return (
    <div id="#questions" className={classes["wrapper"]}>
      <div className={classes["title"]}>{t("Frequently asked questions")}</div>
      <Question />
    </div>
  );
};

export default Questions;
